"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PICKER_PAGE_SIZE = exports.PAGE_SIZE_OPTIONS = exports.MAX_PAGE_SIZE = exports.DEFAULT_PAGE_SIZE = exports.DEFAULT_PAGE_NUMBER = void 0;
var DEFAULT_PAGE_NUMBER = 1;
exports.DEFAULT_PAGE_NUMBER = DEFAULT_PAGE_NUMBER;
var DEFAULT_PAGE_SIZE = 10;
exports.DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
var MAX_PAGE_SIZE = 100;
exports.MAX_PAGE_SIZE = MAX_PAGE_SIZE;
var PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];
exports.PAGE_SIZE_OPTIONS = PAGE_SIZE_OPTIONS;
/** How many options a select-style picker loads at once. */
var PICKER_PAGE_SIZE = 30;
exports.PICKER_PAGE_SIZE = PICKER_PAGE_SIZE;
